import { render, staticRenderFns } from "./EditPotholes.vue?vue&type=template&id=1bef222d&"
import script from "./EditPotholes.vue?vue&type=script&lang=js&"
export * from "./EditPotholes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports